export default (value: any, args?: any): any => {
    return parseInt(value || 0, 10)
        .toLocaleString("en-IE", {
            style: "currency",
            currency: "EUR",
            useGrouping: false,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        .replace(/€/, "€ ");
};
